import { NavLink } from "react-router-dom";
import routeUrls from "./navbar/navLink";
import { usePageBackground } from "./usePageBackground";
import "../CSS/training.scss";

interface Props {
  /** Page heading, matching the page this stands in for (e.g. "Träning"). */
  title: string;
  /** Route the back link points at. */
  backTo: routeUrls;
  /** Back link text, e.g. "← Hem". */
  backLabel: string;
  /** Message to show in the body. */
  message: string;
  /** "error" styles the message as a problem; "loading" is a quiet status. */
  tone?: "error" | "loading";
  /** Optional retry handler — renders a "Försök igen" button when given. */
  onRetry?: () => void;
}

/**
 * Full-page status/error screen for the training pages. Reuses the `.training`
 * shell so loading and error states keep the site header (with a back link),
 * page background and theme instead of a bare unstyled paragraph.
 */
export function TrainingStatusScreen({ title, backTo, backLabel, message, tone = "loading", onRetry }: Props) {
  usePageBackground();
  return (
    <div className="training">
      <div className="training__header">
        <NavLink to={backTo} className="training__back">{backLabel}</NavLink>
        <h1 className="training__title">{title}</h1>
      </div>
      <div className={`training__status training__status--${tone}`} role={tone === "error" ? "alert" : "status"}>
        <p className="training__status-msg">{message}</p>
        {onRetry && (
          <button type="button" className="training__status-retry" onClick={onRetry}>
            Försök igen
          </button>
        )}
      </div>
    </div>
  );
}
